<div class="route-config">
  <button type="button" (click)="onAddViaRoute()" class="btn btn-via">
    <span>Via</span>
  </button>
  <button type="button" class="btn btn-options"
    [ngClass]="{ 'isOptionActive': routeOptionsData.ToggleOptionsPanel, 'isOption': !routeOptionsData.ToggleOptionsPanel  }"
    (click)="toggleOptionPanel()">
    <span>Options</span>
  </button>
</div>

@if (routeOptionsData.ToggleOptionsPanel) {
  <div class="route-options">
    <label class="checkbox">
      <input type="checkbox" (focus)="onFocusAvoidMotorway()"  (blur) = "onBlurAvoidMotorway()"
        [(ngModel)]="routeOptionsData.AvoidHighways" />
        <span class="tick" Id="avoidMotorwaysTick"></span> <span class="label">Avoid motorways</span>
      </label>
      <label class="checkbox">
        <input type="checkbox"  (focus)="onFocusAvoidToll()"  (blur) = "onBlurAvoidToll()"
          [(ngModel)]="routeOptionsData.AvoidTolls" />
          <span class="tick" Id="avoidTollTick"></span>
          <span class="label">Avoid tolls/congestion charging</span>
        </label>
        <hr />
      </div>
    }
    <label class="route-avoid checkbox">
      <input type="checkbox"  (focus)="onFocusAvoidTraffic()"  (blur) = "onBlurAvoidTraffic()"
        [(ngModel)]="routeOptionsData.AvoidTraffic" />
        <span class="tick" Id="avoidTollTraffic"></span>
        <span class="label">Avoid current traffic</span>
      </label>